var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 20C12.833 17.5277 13.5661 15.111 14.9396 13.0554C16.3132 10.9998 18.2654 9.39761 20.5495 8.45151C22.8335 7.50542 25.3469 7.25787 27.7716 7.74019C30.1964 8.2225 32.4237 9.41301 34.1718 11.1612C35.92 12.9093 37.1105 15.1366 37.5928 17.5614C38.0751 19.9861 37.8276 22.4995 36.8815 24.7835C35.9354 27.0676 34.3333 29.0199 32.2776 30.3934C30.222 31.7669 27.8053 32.5 25.333 32.5H11.583C9.26236 32.5 7.03677 31.5781 5.39582 29.9372C3.75488 28.2962 2.83301 26.0707 2.83301 23.75C2.83301 21.4294 3.75488 19.2038 5.39582 17.5628C7.03677 15.9219 9.26236 15 11.583 15C12.3151 14.9997 13.0445 15.0889 13.7549 15.2656",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 18.125L22.833 25.625L19.083 21.875",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApp);
export default __webpack_public_path__ + "static/media/WebApp.8637201d2a175c864407db320df64cf0.svg";
export { ForwardRef as ReactComponent };